<template>
    <b-card :header-bg-variant="'secondary'" body-class="p-0" header-class="py-2">
        <template v-slot:header>
            <b-form-row>
                <b-col>
                    <span class="font-weight-bold">Edit Market Adjustments</span>
                </b-col>
                <b-col cols="5" class="text-right">
                    <b-button class="ml-2 text-dark font-dark" size="sm"
                              :disabled="isEditing"
                              @click="isEditing = !isEditing"
                              variant="outline-secondary"><i class="fa-light fa-edit"></i>
                    </b-button>
                </b-col>
            </b-form-row>
        </template>

        <template v-if="!isEditing">

            <!--view table-->
            <b-table small
                     bordered
                     head-variant="light"
                     class="text-center mb-0"
                     :busy="loading"
                     :items="item"
                     :fields="['name', 'description', 'brand_id', 'level', 'item_class_id', 'item_category_id', 'item_type_id', 'max_dwt', 'amount', 'amount_type']">

                <template v-slot:table-busy>
                    <LoadingSpinner :busy="loading"/>
                </template>
                <template v-slot:cell(level)="data">
                    <span class="text-center">{{ data.index + 1 }}</span>
                </template>
                <template v-slot:cell(name)="data">
                    {{ data.value }}
                </template>
                <template v-slot:cell(level)="data">
                    {{ data.value }}
                </template>
                <template v-slot:cell(description)="data">
                    {{ data.value }}
                </template>
                <template v-slot:cell(adjustment_type)="data">
                    {{ data.value }}
                </template>
                <template v-slot:cell(brand_id)="data">
                    {{ getBrandName(data.value) }}
                </template>
                <template v-slot:cell(item_class_id)="data">
                    {{ getClassName(data.value) }}
                </template>
                <template v-slot:cell(item_category_id)="data">
                    {{ getCategoryName(data.value) }}
                </template>
                <template v-slot:cell(item_type_id)="data">
                    {{ getTypeName(data.value) }}
                </template>
                <template v-slot:cell(max_dwt)="data">
                    {{ data.value }}
                </template>
                <template v-slot:cell(amount)="data">
                    {{ data.value }}
                </template>
                <template v-slot:cell(amount_type)="data">
                    {{ data.value }}
                </template>
            </b-table>
        </template>

        <!-- EDITS -->
        <template v-else>
            <!--add tier & moved into a different add (to avoid writing more UI)
            <b-card class="mb-3" body-class="p-2" bg-variant="light">
                <b-form-row>
                    <b-col cols="2">
                        <label for="" class="mb-1">Level</label>
                        <b-input  v-model="newData.level" size="sm"></b-input>
                    </b-col>
                    <b-col cols="3">
                        <label for="" class="mb-1">Max Dwt</label>
                        <b-input v-model="newData.max_dwt" size="sm"></b-input>
                    </b-col>
                    <b-col cols="2">
                        <label for="" class="mb-1">Percentage</label>
                        <b-input v-model="newData.percentage" size="sm"></b-input>
                    </b-col>
                    <b-col>
                        <label for="" class="mb-1">Description</label>
                        <div class="d-flex align-items-center">
                            <b-input v-model="description" size="sm"></b-input>
                            <b-button size="sm"
                                      class="ml-1"
                                      @click="addTier"
                                      variant="success">
                                <i class="fa-regular fa-plus"></i>
                            </b-button>
                        </div>
                    </b-col>
                </b-form-row>
            </b-card>
            -->

            <!--edit table-->
            <b-table small
                     class="text-center"
                     :items="item"
                     :fields="['name', 'description', 'brand_id', 'level', 'item_class_id', 'item_category_id', 'item_type_id', 'max_dwt', 'amount', 'amount_type']">
                <template v-slot:cell(level)="data">
                    <span class="text-center">{{ data.index + 1 }}</span>
                </template>
                <template v-slot:cell(name)="data">
                    <b-input @focus="$event.target.select()" size="sm" v-model="data.item.name"></b-input>
                </template>
                <template v-slot:cell(description)="data">
                    <b-input @focus="$event.target.select()" size="sm" v-model="data.item.description"></b-input>
                </template>
                <template v-slot:cell(adjustment_type)="data">
                    <b-input @focus="$event.target.select()" size="sm" v-model="data.item.adjustment_type"></b-input>
                </template>
                <template v-slot:cell(level)="data">
                    <b-input @focus="$event.target.select()" size="sm" v-model="data.item.level"></b-input>
                </template>
                <template v-slot:cell(brand_id)="data">
                    <b-form-select @focus="$event.target.select()" size="sm" v-model="data.item.brand_id" :options="brands"></b-form-select>
                </template>
                <template v-slot:cell(item_class_id)="data">
                    <b-form-select @focus="$event.target.select()" size="sm" v-model="data.item.item_class_id" :options="itemClasses"></b-form-select>
                </template>
                <template v-slot:cell(item_category_id)="data">
                    <b-form-select @focus="$event.target.select()" size="sm" v-model="data.item.item_category_id" :options="itemCategories"></b-form-select>
                </template>
                <template v-slot:cell(item_type_id)="data">
                    <b-form-select @focus="$event.target.select()" size="sm" v-model="data.item.item_type_id" :options="itemTypes"></b-form-select>
                </template>
                <template v-slot:cell(max_dwt)="data">
                    <b-input @focus="$event.target.select()" size="sm" v-model="data.item.max_dwt"></b-input>
                </template>
                <template v-slot:cell(amount)="data">
                    <b-input @focus="$event.target.select()" size="sm" v-model="data.item.amount"></b-input>
                </template>
                <template v-slot:cell(amount_type)="data">
                    <div class="d-flex align-items-center">
                        <b-form-select @focus="$event.target.select()" size="sm" v-model="data.item.amount_type" :options="['%', 'fixed', 'override']"></b-form-select>
                        <div class="d-flex align-items-center">
                            <i
                               v-b-tooltip.hover
                               title="Delete Level"
                               @click="deleteRow(data.index)"
                               class="mx-2 pointer fa-regular fa-times text-danger">
                            </i>
                        </div>
                    </div>
                </template>
            </b-table>


            <!-- save/cancel -->
            <b-card body-class="mb-0 p-2" class="mb-0" bg-variant="light">
                <div class="text-right">
                    <b-button size="sm"
                              v-b-tooltip.hover
                              title="Adds new row"
                              variant="primary"
                              @click="addNew">Add New <i class="ml-1 fa-regular fa-file"></i>
                    </b-button>
                    <b-button size="sm"
                              v-b-tooltip.hover
                              class="ml-2"
                              title="Cancel all deletes, edits or additions"
                              variant="secondary"
                              @click="cancelTableEdits">Cancel <i class="ml-1 fa-regular fa-times"></i>
                    </b-button>
                    <b-button size="sm"
                              variant="success"
                              class="ml-2"
                              v-b-tooltip.hover
                              title="Save deletes, edits or additions"
                              @click="saveTableEdits">Save
                        <i v-if="!isSaving" class="ml-1 fa-regular fa-check"></i>
                        <i v-else class="fa-regular fa-spin fa-spinner" ></i>
                    </b-button>
                </div>
            </b-card>


        </template>


    </b-card>
</template>

<script>
    import _ from 'lodash';
    import LoadingSpinner from '@/components/LoadingSpinner';

    export default {
        name: 'adjustment-table',
        components: {LoadingSpinner},
        data() {
            return {
                underscore: _,
                isEditing: false,
                isSaving: false,
                loading: true,
                item: [],
                itemBackup: [],
                itemClasses:[],
                itemTypes: [],
                itemCategories: [],
                brands: [],
                newData: {
                    level: null,
                    max_dwt: null,
                    percentage: null,
                    description: null,
                },
            };
        },
        watch: {
            /*saving(val) {
                console.log('fired');
                if(!val) {
                    this.isSaving = false;
                    this.isEditing = false;
                }
            }*/
        },
        mounted() {
            this.$http.all([
                this.$store.dispatch('GET_REQUEST', '/items/classes'),
                this.$store.dispatch('GET_REQUEST', '/items/types'),
                this.$store.dispatch('GET_REQUEST', '/items/categories'),
                this.$store.dispatch('GET_REQUEST', '/brands'),
                this.$http.post('/debug/getMarketRates'),
            ]).then(this.$http.spread((classesResponse, itemTypesResponse, categoryResponse, brands, items) => {
                this.itemClasses = _.map(classesResponse.data.data, (e) => {
                    return {
                        value: e.id,
                        text: e.name
                    }
                });
                this.itemClasses.push({text: '', value: null});

                this.brands = _.map(brands.data.data, (brand) => {
                    return {
                        value: brand.id,
                        text: brand.name
                    }
                });
                this.brands.push({text: '', value: null});

                this.itemTypes = _.map(itemTypesResponse.data.data, (e) => {
                    return {
                        value: e.id,
                        text: e.name
                    }
                });
                this.itemTypes.push({text: '', value: null});

                this.itemCategories = _.map(categoryResponse.data.data, (e) => {
                    return {
                        value: e.id,
                        text: e.name
                    }
                });
                this.itemCategories.push({text: '', value: null});

                this.item = items.data.data;
                this.itemBackup = _.cloneDeep(this.item);
                this.loading = false;
            }));
        },
        methods: {
            deleteRow(index) {
//                console.log(item);
                this.item.splice(index,1);
            },
            addNew() {
                this.item.push(
                    {
                        'name':null,
                        'description':null,
                        'adjustment_type':'adjustment',
                        'brand_id':null,
                        'level':null,
                        'item_class_id':null,
                        'item_category_id':null,
                        'item_type_id':null,
                        'max_dwt':null,
                        'amount':null,
                        'amount_type':'%'
                    }
                )
            },
            getClassName(id) {
                return (_.find(this.itemClasses, ['value', id]) || {'text': ''} ).text;
            },
            getCategoryName(id) {
                return (_.find(this.itemCategories, ['value', id]) || {'text': ''} ).text;
            },
            getTypeName(id) {
                return (_.find(this.itemTypes, ['value', id]) || {'text': ''} ).text;
            },
            getBrandName(id) {
                return (_.find(this.brands, ['value', id]) || {'text': ''} ).text;
            },
            cancelTableEdits() {
                this.item = _.cloneDeep(this.itemBackup);
                this.isEditing = false;
            },
            saveTableEdits() {
                for(let i = 0; i < this.item.length; i++) {
                    let column = this.item[i];
                    if (!column.name) {
                        this.$bvModal.msgBoxOk("Name is required", {
                            title: "Input Error",
                            size: 'md',
                            buttonSize: 'sm',
                            okVariant: 'danger',
                            headerClass: 'p-2 border-bottom-0 text-center d-block',
                            footerClass: 'p-2 border-top-0',
                        });
                        return;
                    }
                    if (!column.description) {
                        this.$bvModal.msgBoxOk("description is required", {
                            title: "Input Error",
                            size: 'md',
                            buttonSize: 'sm',
                            okVariant: 'danger',
                            headerClass: 'p-2 border-bottom-0 text-center d-block',
                            footerClass: 'p-2 border-top-0',
                        });
                        return;
                    }
                    if (!column.amount) {
                        this.$bvModal.msgBoxOk("amount is required", {
                            title: "Input Error",
                            size: 'md',
                            buttonSize: 'sm',
                            okVariant: 'danger',
                            headerClass: 'p-2 border-bottom-0 text-center d-block',
                            footerClass: 'p-2 border-top-0',
                        });
                        return;
                    }
                }
                this.isSaving = true;
                this.$http.post('/debug/updateMarketRates',
                    {
                        'data': this.item
                    }).then((result) =>{
                    this.item = result.data.data;
                    this.itemBackup = _.cloneDeep(this.item);
                    this.isEditing = false;
                }).finally(()=>{
                    this.isSaving = false;
                });
            }
        }


    };
</script>

<style scoped>

</style>
